var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:[
    'poster-play',
    { 'available': !_vm.isLoading },
    { 'always-visible': _vm.alwaysVisible },
    { 'hide-from-medium': _vm.alwaysVisible ? false : _vm.deviceVisibility === _vm.PLAY_VISIBILITY.MOBILE },
    { 'show-from-medium': _vm.alwaysVisible ? false : _vm.deviceVisibility === _vm.PLAY_VISIBILITY.DESKTOP }
  ],attrs:{"tabindex":"-1","aria-label":_vm.altPlay}},[_c('wptv-icon',{attrs:{"shadow":true,"invert":true,"specific-alt":_vm.altPlay,"aria-hidden":"true","name":"play","width":(_vm.playSize + "px"),"height":(_vm.playSize + "px"),"data-wptv":"item-poster-play-icon"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }